<admin-page-second [title]="'pages.tenants.tenants' | translate">
  <admin-section-standard [title]="'pages.tenants.spaces' | translate">
    <admin-tenants-list></admin-tenants-list>
  </admin-section-standard>
  <admin-section-standard *ngIf="getUsers() && getUsers().length > 0" [title]="'pages.tenants.manage' | translate">
    <admin-tenants-manage></admin-tenants-manage>
  </admin-section-standard>
</admin-page-second>
